import { useRef } from "react";

function CollapseView({
  stock,
  onCancelRequest,
  onEdit,
  onReceiveModal,
  onReconcile,
  onDelete,
}) {
  const menuRef = useRef(null);

  const formatDate = (date) =>
    date &&
    new Date(date).toLocaleString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  const statusColors = {
    Pending: { bg: "#fff8e1", color: "#f59e0b", border: "#fcd34d" },
    Approved: { bg: "#edf7e1", color: "#82c14a", border: "#a3d977" },
    Dispatched: { bg: "#e0f2fe", color: "#0284c7", border: "#7dd3fc" },
    "Partially Received": {
      bg: "#fef3c7",
      color: "#d97706",
      border: "#fbbf24",
    },
    "Pending Fully Received": {
      bg: "#ede9fe",
      color: "#7c3aed",
      border: "#a78bfa",
    },
    "Pending Partially Received": {
      bg: "#fef3c7",
      color: "#d97706",
      border: "#fbbf24",
    },
    "For Reconciliation": {
      bg: "#fce7f3",
      color: "#db2777",
      border: "#f9a8d4",
    },
    Completed: { bg: "#d1fae5", color: "#059669", border: "#6ee7b7" },
    Cancelled: { bg: "#fee2e2", color: "#dc2626", border: "#fca5a5" },
    Disapproved: { bg: "#fee2e2", color: "#dc2626", border: "#fca5a5" },
  };

  const statusStyle = statusColors[stock?.status] || {
    bg: "#f3f4f6",
    color: "#6b7280",
    border: "#d1d5db",
  };

  const InfoRow = ({ icon, label, value }) =>
    value ? (
      <div className="d-flex align-items-center gap-2 mb-2">
        <i
          className={`bi ${icon}`}
          style={{ color: "#82c14a", fontSize: "0.9rem", width: "18px" }}
        />
        <span
          className="text-muted"
          style={{ fontSize: "0.8rem", minWidth: "110px" }}
        >
          {label}
        </span>
        <span className="fw-semibold text-dark" style={{ fontSize: "0.85rem" }}>
          {value}
        </span>
      </div>
    ) : null;
  return (
    <>
      <div
        className="rounded-3 overflow-hidden"
        style={{
          border: "1px solid #e8e8e8",
          background: "#fff",
          transition: "box-shadow 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.08)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        {/* Header */}
        <div
          className="px-3 py-2 d-flex justify-content-between align-items-center"
          style={{
            background: "linear-gradient(135deg, #82c14a 0%, #6ba83a 100%)",
          }}
        >
          <div className="d-flex align-items-center gap-2">
            <i
              className="bi bi-box-seam text-white"
              style={{ fontSize: "1rem" }}
            />
            <span className="text-white fw-bold" style={{ fontSize: "0.9rem" }}>
              {stock?.requestNumber || "N/A"}
            </span>
          </div>
          <span
            className="px-3 py-1 fw-semibold rounded-pill"
            style={{
              backgroundColor: statusStyle.bg,
              color: statusStyle.color,
              border: `1px solid ${statusStyle.border}`,
              fontSize: "0.72rem",
            }}
          >
            {stock?.status}
          </span>
        </div>

        {/* Body */}
        <div className="p-3">
          {/* Info rows */}
          <InfoRow
            icon="bi-shop"
            label="Store"
            value={stock?.destinationLocation?.name}
          />
          <InfoRow
            icon="bi-calendar-event"
            label="Request Date"
            value={formatDate(stock?.requestDate)}
          />
        </div>
        <div
          className="px-3 py-2 d-flex gap-2 align-items-center border-top"
          style={{ background: "#fafafa" }}
          ref={menuRef}
        >
          {![
            "Cancelled",
            "Approved",
            "Dispatched",
            "Pending Partially Received",
            "Pending Fully Received",
            "Disapproved",
            "Completed",
            "Partially Received",
            "For Reconciliation",
          ].includes(stock?.status) && (
            <button
              className="btn btn-success text-white"
              onClick={onCancelRequest}
            >
              <i className="bi bi-pencil-fill me-2"></i> Cancel Request
            </button>
          )}
          {["Dispatched"].includes(stock?.status) && (
            <button
              className="btn btn-success text-white"
              onClick={onReceiveModal}
            >
              <i className="bi bi-pencil-fill me-2"></i> Receive
            </button>
          )}

          {["Disapproved"].includes(stock?.status) && (
            <button
              className="btn btn-success text-white"
              onClick={onReconcile}
            >
              <i className="bi bi-pencil-fill me-2"></i> Ask to Reconcile
            </button>
          )}

          <button
            className="btn text-dark"
            style={{ backgroundColor: "#d1d1d1" }}
            onClick={onEdit}
          >
            <i className="bi bi-eye me-2"></i> View
          </button>
        </div>
      </div>

      {/* <div className="border p-3 rounded bg-white">
        <div className="mb-3">
          <p className="mb-1">
            <strong>Store:</strong> {stock?.sourceLocation?.name}
          </p>
          <p className="mb-1">
            <strong>Request Number:</strong> {stock?.requestNumber}
          </p>
          <p className="mb-1">
            <strong>Request Date:</strong>{" "}
            {stock?.requestDate &&
              new Date(stock?.requestDate).toLocaleString("en-US", {
                month: "long", // March
                day: "numeric", // 2
                year: "numeric", // 2025
                hour: "numeric", // 5
                minute: "2-digit", // 15
                hour12: true, // am/pm
              })}
          </p>
        </div>

        <div className="d-flex gap-2">
          {![
            "Cancelled",
            "Approved",
            "Dispatched",
            "Pending Partially Received",
            "Pending Fully Received",
            "Disapproved",
            "Completed",
            "Partially Received",
            "For Reconciliation",
          ].includes(stock?.status) && (
            <button
              className="btn btn-success text-white"
              onClick={onCancelRequest}
            >
              <i className="bi bi-pencil-fill me-2"></i> Cancel Request
            </button>
          )}
          {["Dispatched"].includes(stock?.status) && (
            <button
              className="btn btn-success text-white"
              onClick={onReceiveModal}
            >
              <i className="bi bi-pencil-fill me-2"></i> Receive
            </button>
          )}

          {["Disapproved"].includes(stock?.status) && (
            <button
              className="btn btn-success text-white"
              onClick={onReconcile}
            >
              <i className="bi bi-pencil-fill me-2"></i> Ask to Reconcile
            </button>
          )}

          <button
            className="btn text-dark"
            style={{ backgroundColor: "#d1d1d1" }}
            onClick={onEdit}
          >
            <i className="bi bi-eye me-2"></i> View
          </button>
         
        </div>
      </div> */}
    </>
  );
}

export default CollapseView;
